import { render, staticRenderFns } from "./advertisement.vue?vue&type=template&id=2802face&"
import script from "./advertisement.vue?vue&type=script&lang=js&"
export * from "./advertisement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports